// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"05d85c84","754":"16d7e299"}[chunkId] + ".chunk.js";
};